'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _propTypes = require('./prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var OFFSET_MARGIN = 65;
var DEFAULT_STYLE = {
    top: 'auto',
    bottom: 0
};

var ActionBar = _react2['default'].createClass({
    displayName: 'ActionBar',


    propTypes: _propTypes.ActionBar,

    //  ----  LIFECYCLE  ----------------------------------

    getDefaultProps: function getDefaultProps() {
        return {
            'canInsertEverywhere': true,
            'disableButtons': false,
            'continueInsteadOfInsert': false,
            'onContinue': null
        };
    },


    //  ----  BEHAVIOR  -----------------------------------

    insertSignature: function insertSignature(insertEverywhere) {
        this.props.onInsert(insertEverywhere);
    },
    close: function close() {
        this.props.onClose();
    },
    captureRef: function captureRef(node) {
        if (node) {
            this.node = node;
        }
    },
    getStyle: function getStyle() {
        var topOffset = this.props.topOffset;

        // If no offset provided, use the default styles to fix the bar to the
        // bottom of the window

        if (!topOffset) {
            return DEFAULT_STYLE;
        }

        if (topOffset) {
            var windowHeight = window.innerHeight;
            var elemHeight = this.node ? this.node.clientHeight : 0;

            // If element will be pushed off the screen with this new offset,
            // then use the default style to fix to the bottom of the window
            // instead
            if (elemHeight + topOffset + OFFSET_MARGIN > windowHeight) {
                return DEFAULT_STYLE;
            }

            return {
                top: topOffset + OFFSET_MARGIN,
                bottom: 'auto'
            };
        }
    },


    //  ----  RENDERING  ----------------------------------

    render: function render() {

        var style = this.getStyle();
        var buttons = [];
        var buttonProps = [{
            'buttonId': 'insertButton',
            'buttonColor': 'white',
            'buttonHoverColor': this.props.isMobile ? 'white' : 'cerulean',
            'buttonTextColor': 'cerulean',
            'buttonHoverTextColor': this.props.isMobile ? 'cerulean' : 'white',
            'className': this.props.disableButtons ? void 0 : 'whitelabel-secondary-button',
            'buttonBorderColor': this.props.disableButtons ? 'cinder-block' : 'cerulean',
            'disabled': this.props.disableButtons,
            'intl': this.props.intl
        }, this.props.canInsertEverywhere ? {
            'buttonId': 'insertEverywhereButton',
            'buttonColor': 'cerulean',
            'buttonTextColor': 'white',
            'buttonHoverColor': this.props.isMobile ? 'cerulean' : null,
            'buttonHoverTextColor': 'white',
            'className': this.props.disableButtons ? void 0 : 'whitelabel-primary-button',
            'buttonBorderColor': this.props.disableButtons ? 'cinder-block' : 'cerulean',
            'disabled': this.props.disableButtons,
            'intl': this.props.intl
        } : void 0];

        var continueButtonProps = {
            'buttonId': 'continueButton',
            'buttonColor': 'cerulean',
            'buttonTextColor': 'white',
            'buttonHoverColor': this.props.isMobile ? 'cerulean' : null,
            'buttonBorderColor': this.props.disableButtons ? 'cinder-block' : 'cerulean',
            'buttonHoverTextColor': 'white',
            'className': 'whitelabel-primary-button',
            'intl': this.props.intl
        };

        if (this.props.continueInsteadOfInsert) {

            buttons.push(_react2['default'].createElement(_button2['default'], _extends({
                key: 'sign-modal-button-continue',
                buttonText: this.props.intl.formatMessage({ id: 'signModal.actions.continue.labelText' }, { 'everywhere': i }),
                disabled: this.props.disableButtons,
                onClick: this.props.onContinue
            }, continueButtonProps)));
        } else {

            // Normal insert buttons
            for (var i = 0; i < 2; i++) {
                if (buttonProps[i]) {
                    var buttonText;
                    if (i === 0 && !this.props.canInsertEverywhere && this.props.buttonText) {
                        buttonText = this.props.buttonText;
                    } else {
                        buttonText = this.props.intl.formatMessage({ id: 'signModal.actions.insert.linkText' }, { 'everywhere': i });
                    }
                    buttons.push(_react2['default'].createElement(_button2['default'], _extends({
                        key: 'sign-modal-button-' + i,
                        buttonText: buttonText,
                        onClick: this.props.disableButtons ? null : this.insertSignature.bind(null, i === 1)
                    }, buttonProps[i])));
                }
            }
        }

        var message = this.props.message;
        if (message == void 0) {
            // null = don't show a message
            message = _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.actions.legal.labelText', values: { type: this.props.type } });
        }

        return _react2['default'].createElement(
            'div',
            { className: 'm-sign-modal--action-bar', style: style, ref: this.captureRef },
            _react2['default'].createElement(
                'div',
                { className: 'm-sign-modal--action-bar--inner' },
                _react2['default'].createElement(
                    'div',
                    { className: 'm-sign-modal--action-bar--close-link m-sign-modal--action--bar--left' },
                    _react2['default'].createElement(
                        'a',
                        { href: 'javascript:;', onClick: this.close },
                        _react2['default'].createElement('span', { className: 'm-sign-modal--action-bar--close-link--arrow' }),
                        _react2['default'].createElement(
                            'span',
                            { className: 'm-sign-modal--action-bar--close-link--text' },
                            _react2['default'].createElement(_reactIntl.FormattedMessage, { id: 'signModal.actions.back.linkText' })
                        )
                    )
                ),
                _react2['default'].createElement(
                    'div',
                    { className: 'm-sign-modal--action-bar--right' },
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-sign-modal--action-bar--message' },
                        message || ''
                    ),
                    _react2['default'].createElement(
                        'div',
                        { className: 'm-sign-modal--action-bar--buttons' },
                        buttons
                    )
                )
            )
        );
    }
});

module.exports = ActionBar;


/*****************
 ** WEBPACK FOOTER
 ** ./src/ui/signature-modal/action-bar.jsx
 ** module id = 793
 ** module chunks = 0 1
 **/